import { Row, Typography } from 'antd';
import React, { useEffect } from 'react';

import { useLocation } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import {
  Container, TextSection, Logo, MainSection, Footer, FooterLogo, FooterText,
} from './styles';
import analytics from '../../infra/analytics';
import { APPOINTMENT_CONFIRMATION, SITE_NAME } from '../../constants/analytics';
import { FONT } from '../../styles/color';
import { StylePageSubtitle, StylePageTitle } from '../../styles/sharedStyleComponets';
import { QUERIES } from '../../styles/breakpoint';

const { Text } = Typography;

const Thanks = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    analytics.logPageViewEvent(APPOINTMENT_CONFIRMATION, {
      site: SITE_NAME,
      page_path: pathname,
    });
  }, [pathname]);
  const isMobile = useMediaQuery({ query: QUERIES.mobile });
  return (
    <Container>
      {
        !isMobile && (
          <header>
            <Logo alt="logo" width="70%" height="68px" src="/amplar-logo.svg" />
          </header>
        )
      }
      <StylePageTitle
        level={2}
        style={{
          marginBottom: isMobile ? '20px' : '70px',
        }}
      >
        Appointment Confirmation
      </StylePageTitle>

      <MainSection>
        <Typography.Title
          level={isMobile ? 5 : 3}
          style={{
            marginBottom: isMobile ? '20px' : '70px', fontWeight: 800, color: FONT,
          }}
        >
          Thank you for taking the time to provide us with your details. We look forward to helping you.
        </Typography.Title>
      </MainSection>
      <TextSection>
        <Row>
          {' '}
          <StylePageSubtitle style={{ textAlign: 'left' }}>
            You will receive an email and SMS confirming your appointment shortly.
          </StylePageSubtitle>
        </Row>

        <Row style={{ marginTop: isMobile ? '20px' : '30px' }}>
          <Text style={{ textAlign: 'left', fontSize: isMobile ? '12px' : '18px' }}>
            If you need to contact us prior or after your consultation, please find our contact details:
            <br />
            {'   Phone: 03 7023 2883'}
            <br />
            {'   Email: '}
            <a
              style={{ textDecoration: 'underline' }}
              href="mailto:admin@telecareonline.com.au"
            >
              amplarhealthpsychology@telecare.com.au
            </a>
          </Text>
        </Row>
      </TextSection>

      <Footer>
        <StylePageSubtitle style={{
          marginTop: isMobile ? '10px' : '50px', display: 'block', textDecoration: 'underline',
        }}
        >
          <a
            href="https://virtualpsychology.amplarhealth.com.au/"
          >
            Back to Home
          </a>
        </StylePageSubtitle>
        <a href="https://www.telecare.com.au/" target="_blank" rel="noopener noreferrer">
          <FooterLogo src="/telecare-logo.svg" alt="Telecare Logo" />
        </a>
        <FooterText>Service powered by Telecare</FooterText>
      </Footer>
    </Container>
  );
};

export default Thanks;
